function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#1E90FF",
  fillRule: "evenodd",
  d: "M21.997 5.498a7.432 7.432 0 0 1 10.265 2.259l16.618 27.56a6.5 6.5 0 0 1 .108 6.586l-.14.23a7.302 7.302 0 0 1-6.23 3.367H9.382a7.302 7.302 0 0 1-6.37-3.683l-.13-.246a6.5 6.5 0 0 1 .238-6.254l16.618-27.56a7.432 7.432 0 0 1 2.26-2.26zm5.939 3.89a3.207 3.207 0 0 0-4.493.622L6.803 37.592a2.167 2.167 0 0 0 0 2.166l.105.167a2.838 2.838 0 0 0 2.474 1.242h33.236a2.838 2.838 0 0 0 2.579-1.409l.082-.16a2.167 2.167 0 0 0-.104-2.028L28.557 10.01a3.207 3.207 0 0 0-.621-.621zm-.404 23.747a2.167 2.167 0 1 1-3.064 3.064 2.167 2.167 0 0 1 3.064-3.064zM26 17.333l.155.006a2.167 2.167 0 0 1 2.012 2.161v8.667a2.167 2.167 0 1 1-4.334 0V19.5l.006-.155A2.167 2.167 0 0 1 26 17.333z"
});

var SvgLine = function SvgLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/line.32d29593.svg";
export { ForwardRef as ReactComponent };